import { render, staticRenderFns } from "./ChangeProfile.vue?vue&type=template&id=4c72b150&scoped=true&"
import script from "./ChangeProfile.vue?vue&type=script&lang=js&"
export * from "./ChangeProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c72b150",
  null
  
)

export default component.exports